import {RouteBase} from './route-base';

export class OrbitRoute extends RouteBase {

    /**
     * Overrides base class
     * @return {boolean}
     * @private
     */
    protected _isOrbitRoute(): boolean {
        return true;
    }
}
